// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Info banner ── */
.info-banner {
  background: #FFFFFF;
  border: 0.5px solid var(--theme-main-color, #055C8D);
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 28px;
  margin-right: 8px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 12px;
  letter-spacing: -0.0686271px;
  color: var(--theme-main-color, #055C8D);
}

.info-banner .ti {
  color: var(--theme-main-color, #055C8D);
  flex-shrink: 0;
  margin-top: 1px;
}

.info-banner-text {
  color: var(--theme-main-color, #055C8D);
  line-height: 1.55;
}

/* ── Section ── */
.settings-section {
  margin-bottom: 24px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 12px;
  letter-spacing: -0.0686271px;
}

.section-title {
  color: var(--theme-main-color, #055C8D);
  margin-bottom: 10px;
}

/* ── Settings card ── */
.settings-card {
  background: #fff;
  border: 0.5px solid var(--theme-main-color, #055C8D);
  border-radius: 12px;
  overflow: hidden;
  margin-right: 8px;
}

/* ── Setting row ── */
.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
}

.setting-row + .setting-row {
  border-top: 0.5px solid var(--theme-main-color, #055C8D);
}

.setting-info {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.setting-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.setting-icon {
  background: var(--theme-main-color, #055C8D);
  color: #FFFFFF;
}

.setting-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-main-color, #055C8D);
  margin-bottom: 2px;
}

.setting-desc {
  line-height: 1.5;
}

.status-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.2s;
}

.status-text {
  font-size: 11px;
  font-weight: 500;
  transition: color 0.2s;
}

.status-text.muted {
  color: #9ca3af;
}

.status-text.active {
  color: #e65100;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
